export enum StorageKey {
    TOKEN = 'token',
    CLIENT = 'client',
}
